import styled from 'styled-components/macro'

import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

const Footer = styled.div`
  display: flex;
  flex-basis: 100%;
  justify-content: center;
  margin-bottom: 20px;

  font-size: 14px;
  line-height: 21px;
`

const Link = styled.a`
  color: ${getToken('color-primary')};
  font-weight: bold;
  text-decoration: underline;
`

function SignupDialogFormFooter() {
  return (
    <Footer>
      By clicking sign up, you agree that you have read and accepted our{' '}
      <Link
        href="https://loadsmart.com/master-saas-and-services-agreement"
        target="_blank"
        rel="noopener noreferrer"
      >
        Terms of Service
      </Link>{' '}
      and{' '}
      <Link href="https://loadsmart.com/user-agreement" target="_blank" rel="noopener noreferrer">
        User Agreement
      </Link>
    </Footer>
  )
}

export { SignupDialogFormFooter }
